import { ComponentSelectChannel } from "src/Components/ClaimPointFromEcom";

export const PageSelectChannel = () => {
    return <ComponentSelectChannel />;
};
